module.exports = __webpack_public_path__ + "img/liushui (1).ec91ef76.png";